import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import App from 'resizement/scripts/resize';
import { menuAim } from 'cfa-nav/scripts/menu-aim';
import { TimelineLite } from 'gsap';

Snappy.Component.CFANav = class CFANav extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-nav';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();

        if (App.isDesktop) {
            this.initSticky();
            this.initMenuAim();
            this.initSearch();
            this.initKeyboardNavigation();
            this.switchTabOrder();
        } else {
            this.initMobile();
        }
    }

    setVars() {
        this.stickyElement = this.$element.find('.js-sticky-nav');
        this.stickyContainer = this.$element.find('.js-sticky-nav-container');

        this.navContainer = this.$element.find('.js-cfa-nav-container');
        this.mobileNavOpener = this.$element.find('.js-mobile-nav-opener');

        this.mainNav = this.$element.find('.js-cfa-main-nav');
        this.subNav = this.$element.find('.js-cfa-sub-nav');

        this.menu = this.$element.find('.js-cfa-menu');
        this.menuContent = this.$element.find('.js-cfa-menu-content');
        this.submenu = this.$element.find('.js-cfa-submenu');
        this.menuItem = this.$element.find('.js-menu-item');
        this.menuItemForward = this.$element.find('.js-menu-item-forward');
        this.menuItemBackward = this.$element.find('.js-menu-item-backward');
        this.menuItemPrimary = this.$element.find('.js-menu-item-primary');
        this.menuItemSecondary = this.$element.find('.js-menu-item-secondary');
        this.subNavLink = this.$element.find('.js-subnav-link');
        this.activeMenuItemPrimary = null;
        this.activeMenuItemSecondary = null;

        this.isSearchOpened = false;
        this.search = this.$element.find('.js-cfa-search');
        this.openSearch = this.$element.find('.js-cfa-search-open');
        this.closeSearch = this.$element.find('.js-cfa-search-close');
        this.searchInput = this.$element.find('.js-cfa-search-input');
        this.searchUrl = this.search.data('url');

        this.isMobile = !App.isDesktop;
        this.isRunning = false;
        this.isDesktopMenuOpened = false;
        this.isMobileMenuOpened = false;
        this.isMenuFocused = false;
        this.isSticky = false;
        this.translateValue = 0;
    }

    setEventListeners() {
        this.$window.on('resize:finished', this.bindedResize = this.onResize.bind(this));
        this.$body.on('body:block', this.onBodyBlock.bind(this));
        this.$body.on('body:unblock', this.onBodyUnblock.bind(this));

        this.navContainer.on('transitionend', this.onNavTransitionEnd.bind(this));
        this.openSearch.on('click', this.onSearchOpen.bind(this));
        this.searchInput.on('keyup', this.onSearchKeyup.bind(this));
    }

    initKeyboardNavigation() {
        this.menuItemPrimary.on('focus', (event) => this.onFocusMenuItemPrimary(event));
        this.menuItemPrimary.on('keydown', (event) => this.onKeydownMenuItemPrimary(event));
        this.menuItemSecondary.on('focus', (event) => this.onFocusMenuItemSecondary(event));
    }

    onKeydownMenuItemPrimary( event ) {
        const keyCode = event.which;

        switch( keyCode ) {
            case 13:
                const activeMenuItemPrimiry = $(event.target).parent().get(0);

                if ( activeMenuItemPrimiry === this.activeMenuItemPrimiry ) {
                    return;
                }

                event.preventDefault();
                this.activeMenuItemPrimiry = activeMenuItemPrimiry;
                this.activateMainMenu( this.activeMenuItemPrimiry );
        }
    }

    onFocusMenuItemPrimary(){
        if ( this.activeMenuItemSecondary ) {
            this.deactivateSubMenu( this.activeMenuItemSecondary );
            this.closeCurrentSubMenu( this.activeMenuItemSecondary );
        }

        if ( this.activeMenuItemPrimiry ) {
            this.deactivateMainMenu( this.activeMenuItemPrimiry );
            this.closeCurrentMenu( this.activeMenuItemPrimiry );
            this.activeMenuItemPrimiry = null;
        }
    }

    onFocusMenuItemSecondary(event) {
        if ( this.activeMenuItemSecondary ) {
            this.deactivateSubMenu( this.activeMenuItemSecondary );
        }

        this.activeMenuItemSecondary = $(event.target).parent().get(0);
        this.activateSubMenu(this.activeMenuItemSecondary);
    }

    //destroyKeyboardNavigation() {
    //    this.menuItemPrimary.off('focus', this.bindedPrimaryFocus);
    //    this.menuItemSecondary.off('focus', this.bindedSecondaryFocus);
    //    this.openSearch.off('focus', this.bindedSearchFocus);
    //    this.subNavLink.off('focus', this.bindedSubNavFocus);
    //}

    initSearch() {
        this.search.on('transitionend', this.onSearchTransitionEnd.bind(this));
        this.closeSearch.on('click', this.onSearchClose.bind(this));
    }

    onSearchKeyup(e) {
        if (e && e.keyCode === 13) {
            this.onSearchSubmit();
        }
    }

    onSearchSubmit() {
        const keyword = this.searchInput.val();

        if (keyword === '') {
            return;
        }

        window.location.href = this.searchUrl + '?keyword=' + keyword + '&page=1';
    }

    onSearchOpen(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === "function") {
            e.preventDefault();
        }

        const inputValue = this.searchInput.val();

        if (this.isMobile) {
            if (inputValue !== '') {
                this.onSearchSubmit();
            }

            return;
        }

        if (this.isSearchOpened && inputValue !== '') {
            this.onSearchSubmit();
        } else {
            this.isSearchOpened = true;
            this.search.addClass('cfa-search--opened');
            this.search.addClass('cfa-search--visible');
        }
    }

    onSearchClose(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === "function") {
            e.preventDefault();
        }

        this.isSearchOpened = false;
        this.search.removeClass('cfa-search--opened');
        this.openSearch.focus();
    }

    onSearchTransitionEnd(e) {
        if (e.target !== this.search[0]) {
            return;
        }

        if (this.isSearchOpened) {
            this.searchInput.focus();
        } else {
            this.search.removeClass('cfa-search--visible');
        }
    }

    initMenuAim() {
        this.mainNav.menuAim({
            rowSelector: "> ul > li",
            submenuDirection: "below",
            tolerance: 0,
            activate: function(el) {
                this.activateMainMenu(el);
            }.bind(this),
            deactivate: function(el) {
                this.deactivateMainMenu(el);
            }.bind(this),
            exitMenu: this.closeCurrentMenu.bind(this)
        });

        this.subNav.menuAim({
            activate: function(el) {
                this.activateSubMenu(el);
            }.bind(this),
            deactivate: function(el) {
                this.deactivateSubMenu(el);
            }.bind(this),
            exitMenu: this.closeCurrentSubMenu.bind(this)
        });
    }

    activateMainMenu(el) {
        if (this.isSearchOpened) {
            return;
        }

        const newMenu = el.querySelector('.js-cfa-menu');

        el.classList.add('cfa-nav__item--active');

        if (newMenu && !this.isDesktopMenuOpened) {
            let newContent = newMenu.querySelector('.js-cfa-menu-content');

            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween.set(newMenu, { display: 'block' });
            this.tween.set(newContent, { autoAlpha: 1 });
            this.tween.to(newMenu, .2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();

            newMenu.style.pointerEvents = 'auto';

            this.isDesktopMenuOpened = true;
            this.currentDesktopMenu = newMenu;
        } else if (newMenu && this.isDesktopMenuOpened) {
            let oldMenu = this.currentDesktopMenu,
                oldContent = oldMenu.querySelector('.js-cfa-menu-content'),
                newContent = newMenu.querySelector('.js-cfa-menu-content');

            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(oldContent, .2, { autoAlpha: 0, ease: Power0.easeNone })
                .set(newMenu, { display: 'block', autoAlpha: 1 })
                .set(oldMenu, { display: 'none', autoAlpha: 0 })
                .to(newContent, .2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();

            oldMenu.style.pointerEvents = 'none';
            newMenu.style.pointerEvents = 'auto';

            this.currentDesktopMenu = newMenu;
        } else {
            this.closeCurrentMenu();
        }
    }

    closeCurrentMenu() {
        if (this.isDesktopMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(this.currentDesktopMenu, .2, { autoAlpha: 0, ease: Power0.easeNone })
                .set(this.currentDesktopMenu, { display: 'none' })
                .set(this.currentDesktopMenu.querySelector('.js-cfa-menu-content'), { autoAlpha: 1 });
            this.tween.play();

            this.currentDesktopMenu.style.pointerEvents = 'none';

            this.currentDesktopMenu = null;
            this.isDesktopMenuOpened = false;
        }

        return true;
    }

    deactivateMainMenu(el) {
        if (this.isSearchOpened) {
            return;
        }

        el.classList.remove('cfa-nav__item--active');
    }

    activateSubMenu(el) {
        const newSubMenu = el.querySelector('.js-cfa-submenu');

        el.classList.add('cfa-menu__item--active');

        if (newSubMenu && !this.isDesktopSubMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .set(newSubMenu, { display: 'block' })
                .set(this.currentDesktopMenu, { height: (newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight) ? newSubMenu.scrollHeight + 40 : 'auto' })
                .to(newSubMenu, .2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();

            newSubMenu.style.pointerEvents = 'auto';

            this.isDesktopSubMenuOpened = true;
            this.currentDesktopSubMenu = newSubMenu;
        } else if (newSubMenu && this.isDesktopSubMenuOpened) {
            let oldSubMenu = this.currentDesktopSubMenu;

            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .set(newSubMenu, { display: 'block' })
                .set(this.currentDesktopMenu, { height: (newSubMenu.scrollHeight + 40 > this.currentDesktopMenu.scrollHeight) ? newSubMenu.scrollHeight + 40 : 'auto' })
                .to(oldSubMenu, .2, { autoAlpha: 0, ease: Power0.easeNone })
                .set(oldSubMenu, { display: 'none' })
                .to(newSubMenu, .2, { autoAlpha: 1, ease: Power0.easeNone });
            this.tween.play();

            oldSubMenu.style.pointerEvents = 'none';
            newSubMenu.style.pointerEvents = 'auto';

            this.currentDesktopSubMenu = newSubMenu;
        } else {
            this.closeCurrentSubMenu();
        }
    }

    deactivateSubMenu(el) {
        el.classList.remove('cfa-menu__item--active');
    }

    closeCurrentSubMenu() {
        if (this.isDesktopSubMenuOpened) {
            this.tweenPromote(this.tween);
            this.tween = new TimelineLite();
            this.tween
                .to(this.currentDesktopSubMenu, .2, { autoAlpha: 0, ease: Power0.easeNone })
                .set(this.currentDesktopSubMenu, { display: 'none' })
                .set(this.currentDesktopMenu, { height: 'auto' });
            this.tween.play();

            this.currentDesktopSubMenu.style.pointerEvents = 'none';

            this.currentDesktopSubMenu = null;
            this.isDesktopSubMenuOpened = false;
        }

        return true;
    }

    tweenPromote(tween) {
        if (typeof tween === 'undefined' || tween == null)
            return;

        if (typeof tween.progress === 'function' && tween.progress() < 1) {
            tween.pause();
            tween.progress(1);
        }

        if (typeof tween.destroy === 'function') {
            tween.destroy();
        }
    }

    destroyMenuAim() {
        this.mainNav.menuAim("destroy");
        this.subNav.menuAim("destroy");
        this.menu.removeAttr('style');
        this.menuContent.removeAttr('style');
        this.submenu.removeAttr('style');
    }

    initSticky() {
        if (this.$body.hasClass('is-experience-editor')) {
            return;
        }

        this.getStickyData();
        this.onScroll();
        $(window).on('scroll', this.bindedScroll = this.onScroll.bind(this));
    }

    destroySticky() {
        this.deactivateSticky();
        $(window).off('scroll', this.bindedScroll);
    }

    getStickyData() {
        this.stickyOffset = this.stickyContainer.height();
        this.offset = this.stickyElement.offset().top;
    }

    activateSticky() {
        this.stickyContainer.addClass('is-fixed');
        this.stickyContainer.css('height', this.stickyOffset);
    }

    deactivateSticky() {
        this.stickyContainer.removeClass('is-fixed');
        this.stickyContainer.css('height', 'auto');
        this.isSticky = false;
    }

    initMobile() {
        this.mobileNavOpener.on('click', this.bindedHamburgerClick = this.onHamburgerClick.bind(this));
        this.menuItemForward.on('click', this.bindedForwardClick = this.onForwardClick.bind(this));
        this.menuItemBackward.on('click', this.bindedBackwardClick = this.onBackwardClick.bind(this));
    }

    onBodyBlock() {
        this.pageOffset = this.$body.scrollTop();
        this.$body.addClass('is-blocked');
        this.$body.css('top', -this.pageOffset);
    }

    onBodyUnblock() {
        this.$body.css('top', 'initial');
        this.$body.removeClass('is-blocked');
        window.scrollTo(0, this.pageOffset);
    }

    destroyMobile() {
        this.resetMenu();
        this.mobileNavOpener.off('click', this.bindedHamburgerClick);
        this.menuItemForward.off('click', this.bindedForwardClick);
        this.menuItemBackward.off('click', this.bindedBackwardClick);
    }

    resetMenu() {
        this.translateValue = 0;
        this.navContainer.css('transform', '');
        this.menuItem.removeClass('is-active');
    }

    onHamburgerClick() {
        this.isMobileMenuOpened = !this.isMobileMenuOpened;
        this.resetMenu();
        this.toggleHamburger();
        this.toggleMenu();
        this.toggleBodyBlock();
    }

    onNavTransitionEnd(e) {
        if (e.target !== this.navContainer[0]) {
            return;
        }

        this.isRunning = false;
        if (this.translateValue === -100) {
            this.subNav.find('li.is-active').removeClass('is-active');
        } else if (this.translateValue === 0) {
            this.mainNav.find('li.is-active').removeClass('is-active');
        }
    }

    onForwardClick(e) {
        if (typeof e !==  'undefined' && typeof e.preventDefault === "function") {
            e.preventDefault();
        }

        if (this.isRunning) {
            return;
        } else {
            this.isRunning = true;
        }

        const forwardLink = $(e.currentTarget);
        forwardLink.closest('.js-menu-item').addClass('is-active');

        this.translateValue -= 100;
        this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
    }

    onBackwardClick(e) {
        if (typeof e !== 'undefined' && typeof e.preventDefault === "function") {
            e.preventDefault();
        }

        if (this.isRunning) {
            return;
        } else {
            this.isRunning = true;
        }

        //const backwardLink = $(e.currentTarget);

        this.translateValue += 100;
        this.navContainer.css('transform', 'translateX(' + this.translateValue + '%)');
    }

    toggleHamburger() {
        this.mobileNavOpener.toggleClass('is-active', this.isMobileMenuOpened);
    }

    toggleMenu() {
        this.$element.toggleClass('is-mobile-active', this.isMobileMenuOpened);
    }

    toggleBodyBlock() {
        if (this.isMobileMenuOpened) {
            this.$body.trigger('body:block');
        } else {
            this.$body.trigger('body:unblock');
        }
    }

    onScroll() {
        if (this.isSticky !== this.offset < window.pageYOffset) {
            this.isSticky = !this.isSticky;

            if (this.isSticky) {
                this.activateSticky();
            } else {
                this.deactivateSticky();
            }
        }
    }

    onResize() {
        let screenSize;

        if (App.isDesktop) {
            screenSize = 'desktop';
        } else {
            screenSize = 'mobile';
        }

        this.onBreakpointChange(screenSize);
    }

    onBreakpointChange(screenSize) {
        const wasMobile = this.isMobile;
        const isMobile = screenSize === 'mobile';

        if (isMobile && !wasMobile) {
            if (this.isSearchOpened) {
                this.onSearchClose();
            }

            this.destroySticky();
            //this.destroyKeyboardNavigation();
            this.destroyMenuAim();
            this.initMobile();
        } else if (!isMobile && wasMobile) {
            if (this.isMobileMenuOpened) {
                this.isMobileMenuOpened = false;
                this.toggleMenu();
                this.toggleHamburger();
                this.toggleBodyBlock();
            }

            this.destroyMobile();
            this.initSticky();
            this.initMenuAim();
            this.initSearch();
            //this.initKeyboardNavigation();
        }

        this.isMobile = isMobile;
        this.switchTabOrder();
    }

    switchTabOrder() {
        if ( this.isMobile ) {
            this.mainNav.insertAfter(this.search);
        } else {
            this.search.insertAfter(this.mainNav);
        }
    }
};



// WEBPACK FOOTER //
// ./components/cfa-nav/scripts/cfa-nav.js